import { render, staticRenderFns } from "./RegTan.vue?vue&type=template&id=375e312b&scoped=true"
import script from "./RegTan.vue?vue&type=script&lang=js"
export * from "./RegTan.vue?vue&type=script&lang=js"
import style0 from "./RegTan.vue?vue&type=style&index=0&id=375e312b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375e312b",
  null
  
)

export default component.exports